module.exports = __webpack_public_path__ + "img/terroir-moonlit-1-mobile.b7084905.jpg";